import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../data/site";

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-cream py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">
            Word of mouth
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-cocoa mt-3 leading-tight">
            From the guests who came back.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="reveal bg-card-warm border border-cream-deep rounded-2xl p-8 shadow-sm hover:shadow-md transition-all"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <Quote className="text-gold" size={28} aria-hidden="true" />
              <p className="mt-4 text-cocoa text-lg leading-relaxed font-display italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center justify-between border-t border-cream-deep pt-4">
                <div>
                  <div className="text-sm font-semibold text-cocoa">{t.name}</div>
                  <div className="text-xs text-cocoa-soft uppercase tracking-wider">
                    {t.city}
                  </div>
                </div>
                <div className="flex items-center gap-0.5 text-gold">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star
                      key={k}
                      size={14}
                      fill="currentColor"
                      strokeWidth={0}
                      aria-hidden="true"
                    />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
